module.exports = __webpack_public_path__ + "img/scardbg.0cde6cd0.jpg";